export default __webpack_public_path__ + "static/postman-50438548e1ce61f807ae5ddd5e8a9d62.svg";